import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import View from '@play-co/timestep-core/lib/ui/View';
import sounds from 'src/lib/sounds';
import { Feature } from 'src/replicant/analytics';
import { PetEntity } from 'src/game/logic/EntityManager';
import { PetSpeciesID } from 'src/replicant/pet';
import * as Pet from 'src/replicant/pet';
import { petAnimationNames } from 'src/replicant/pet/PetAssets';
import { user } from 'src/StateObserver';
import { MagicLampsGrandPrize } from './MagicLampsGrandPrize';
import { magicLampsGetGrandPrize } from 'src/replicant/match2/magiclamps/magiclamps.getters';
import { ImageScaleView } from '@play-co/timestep-core/ui';

import { AssetGroup } from '@play-co/timestep-core';

type CloseHandler = (result: boolean) => void;
const ui = uiConfig.buruburu.care.confirmation;

export default class PopupMatch2MagicLampsCollect extends PopupBasic {
  private contentWrapper: View;
  private pet: PetEntity;
  private species: PetSpeciesID | undefined;
  private whiteBox: ImageScaleView;
  private grandPrize: MagicLampsGrandPrize;

  constructor(opts: { superview: View; close: CloseHandler }) {
    const height = 560;
    super({
      superview: opts.superview,
      close: () => opts.close(false),
      ...ui.popup,
      height,
      tracking: {
        feature: Feature.MATCH2._,
        $subFeature: Feature.MATCH2.QUIT.POPUP,
      },
    });

    this.buttonClose.removeFromSuperview();
    this.title.updateOpts({ size: 30 });
    this.message.updateOpts({ y: 100 });

    this.contentWrapper = new View({
      superview: this.box,
      width: this.box.style.width,
      height: this.box.style.height,
    });

    new ButtonScaleViewWithText({
      ...ui.okButton,
      y: height - 120,
      superview: this.contentWrapper,
      localeText: () => i18n('match2.magicLamps.promptCollectCancel'),
      onClick: async () => {
        sounds.sfx.play('cancel');
        return opts.close(false);
      },
      tracking: {
        feature: Feature.MATCH2._,
        $subFeature: Feature.MATCH2.MAGIC_LAMPS.CANCEL,
      },
    });

    new ButtonScaleViewWithText({
      ...ui.backButton,
      y: height - 120,
      superview: this.contentWrapper,
      localeText: () => i18n('match2.magicLamps.promptCollectOkay'),
      onClick: async () => {
        sounds.sfx.play('ok');
        return opts.close(true);
      },
      tracking: {
        feature: Feature.MATCH2._,
        $subFeature: Feature.MATCH2.MAGIC_LAMPS.COLLECT,
      },
    });

    this.species = Pet.getters.getCurrentEvolution(user())?.species;
    this.pet = new PetEntity('minigame', this.species);
    this.pet.updateOpts({
      superview: this.contentWrapper,
      x: 155,
      y: height - 160,
      scale: 0.75,
      anchorX: 0.5 * this.pet.style.width,
      anchorY: 0.78 * this.pet.style.height,
    });

    this.whiteBox = new ImageScaleView({
      superview: this.contentWrapper,
      image: 'assets/ui/shop/frames/scroll_cell.png',
      width: 200,
      height: 200,
      x: 417,
      y: height - 250,
      centerOnOrigin: true,
      scaleMethod: '9slice',
      sourceSlices: {
        horizontal: { left: 50, right: 50 },
        vertical: { top: 50, bottom: 50 },
      },
    });

    this.grandPrize = new MagicLampsGrandPrize({
      superview: this.contentWrapper,
      amount: magicLampsGetGrandPrize(),
      x: this.whiteBox.style.x,
      y: this.whiteBox.style.y,
    });
  }

  protected getAssetsGroup() {
    return new AssetGroup(['assets/ui/shop/frames/scroll_cell.png']);
  }

  public init() {
    super.init({
      title: i18n('match2.magicLamps.promptCollectTitle'),
      message: i18n('match2.magicLamps.promptCollectMessage'),
    });
    const petAnimations = petAnimationNames[this.species ?? 'ball'];
    this.pet.setAnimation(petAnimations.very_sad.idle);
  }

  public override async fadeIn() {
    return super.fadeIn();
  }

  public override async fadeOut() {
    return super.fadeOut();
  }
}
